import customGroupsService from '../../services/customGroupsService';

export default (state, groupCode) => {
  const countries = state.fullListOfCountries;

  // Check if this is a custom group
  const customGroup = customGroupsService.urlUtils.parseUrlParam(groupCode);
  if (customGroup) {
    // For custom groups, return countries based on the ISO codes in the URL
    return countries.filter((country) => customGroup.countries.includes(country.iso));
  }

  // Regular group - return countries that belong to this group
  return countries.filter((object) => object.grps.indexOf(groupCode) != -1);
};
